import React from "react";
import { Suspense } from "react";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import Loader from "../Layout/Loader";
import { authRoutes } from "./AuthRoutes";
import Signin from "../Auth/Signin";
import PrivateRoute from "./PrivateRoute";
import PlatformAdminLayout from "../Layout/PlatformAdminLayout";
import CompanyAdminLayout from "../Layout/CompanyAdminLayout";
import meetingHubPlatformRoutes from "./MeetingHubPlatformRoutes";
import meetingHubCompanyRoutes from "./MeetingHubCompanyRoutes";
import { appPath, routePathStripPublicUrl } from "../utils/appPath";
import { platformBasePath, companyBasePath } from "../utils/mhNav";
import { defaultDashboardPath, loginPath } from "../utils/meetingHubAuth";
import AppLayout from "../Layout/Layout";

const Routers = () => {
  const meetingHubPlatformPath = routePathStripPublicUrl(
    appPath(platformBasePath()),
  );
  const meetingHubCompanyPath = routePathStripPublicUrl(
    appPath(companyBasePath()),
  );
  const routerBasename = (process.env.PUBLIC_URL || "").replace(/\/$/, "");

  return (
    <BrowserRouter basename={routerBasename || undefined}>
      <Suspense fallback={<Loader />}>
        <Routes>
          <Route path={"/"} element={<PrivateRoute />}>
            <Route
              index
              element={
                <Navigate
                  to={`/${routePathStripPublicUrl(defaultDashboardPath())}`}
                  replace
                />
              }
            />
            <Route path={meetingHubPlatformPath} element={<AppLayout />}>
              {meetingHubPlatformRoutes}
            </Route>
            <Route path={meetingHubCompanyPath} element={<AppLayout />}>
              {meetingHubCompanyRoutes}
            </Route>
            <Route
              path="*"
              element={
                <Navigate
                  to={`/${routePathStripPublicUrl(defaultDashboardPath())}`}
                  replace
                />
              }
            />
          </Route>

          <Route
            path={routePathStripPublicUrl(loginPath())}
            element={<Signin />}
          />
          {authRoutes.map(({ path, Component }, i) => (
            <Route
              path={routePathStripPublicUrl(path)}
              element={Component}
              key={i}
            />
          ))}
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
};

export default Routers;
